import type { QueryFilterCollection, QuerySortLoose } from "~/helpers/apollo/types";
import type { UIColor } from "@align/ui";

export const getFilterColor = (active: boolean): UIColor => "--color-primary";

export type FilterBookmark = {
  id: string;
  name: string;
  notifyUserOnChangesToOutput: boolean;
  filters: QueryFilterCollection;
  isDefault: boolean;
  columns?: string[] | null;
  sort?: QuerySortLoose | null;
};

export type TenantStatus = "upcomingTenant" | "noUpcomingTenant";

export const tenancyStatusIds = ["vacant", "occupiedTerminated", "occupiedNotTerminated"] as const;
export type TenancyStatus = (typeof tenancyStatusIds)[number];

import type { TenanciesColumnKey } from "~/helpers/entities/tenancy-helpers";

/**
 * Development configuration for temporarily disabling rent roll columns
 * during data model migration.
 *
 * Add column keys here to temporarily disable them in the rent roll.
 * This will:
 * - Remove them from the default columns list
 * - Hide them from column selection UI
 * - Prevent them from being included in queries
 */
export const devDisabledRentrollColumns: TenanciesColumnKey[] = ["arrears"];

/**
 * Helper function to check if a column is disabled in development
 */
export const isColumnDisabledInDev = (columnKey: TenanciesColumnKey): boolean => {
  return devDisabledRentrollColumns.includes(columnKey);
};

/**
 * Helper function to filter out disabled columns from an array
 */
export const filterDisabledColumns = (columns: TenanciesColumnKey[]): TenanciesColumnKey[] => {
  return columns.filter((column) => !isColumnDisabledInDev(column));
};
